import React, { useState } from "react";
import navigate from "@helpers/link-navigate";
import { useLocation } from "@reach/router";
import NProgress from "nprogress";
import Image from "components/image";
import Loading from "components/loading";
import CommonDropdown from "components/dropdowns/common-dropdown";
import ModalDropdown from "components/dropdowns/modal-dropdown";
import { defaultBackGroundImages } from "../product-finder/data";

const BackgroundImage = ({ bgImage, pathname }) => {
    const { asset } = bgImage || {};
    if (bgImage) return <Image className="element-as-bg" width={1240} image={asset} />;

    const defaultBackGroundImageExists = defaultBackGroundImages.find((backgroundImage) => pathname.includes(backgroundImage.key));
    if (defaultBackGroundImageExists) return <img className="element-as-bg" src={defaultBackGroundImageExists.image} alt={`${defaultBackGroundImageExists.key} - Covers`} />;

    return <div className="bg-blue-700 element-as-bg" />;
};

const Container = ({ bgImage, pathname, children }) => (
    <div className="container max-w-3xl">
        <div className="relative">
            <BackgroundImage bgImage={bgImage} pathname={pathname} />
            <div className="flex justify-center md:py-16 py-11 md:px-8 px-10 flex-col relative">
                {children}
            </div>
        </div>
    </div>
);

const Error = ({ bgImage, pathname }) => (
    <Container bgImage={bgImage} pathname={pathname}>
        <h2 className="text-white text-[24px] md:text-[32px] lg:text-[40px] text-center mb-10 uppercase font-semibold">
            Request could not be processed, please try again ...
        </h2>
    </Container>
);

const ProductFindBySize = ({ data: { title, bgImage, linksFindBySize, linksTitle } }) => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(false);
    const location = useLocation();
    const [dropdownOpen, setDropdownOpen] = useState(false);

    const handleGoToCollection = (url) => {
        NProgress.start();
        setLoading(true);
        navigate(url);
    };

    if (error) return <Error />;

    return (
        <Container bgImage={bgImage} pathname={location.pathname}>
            <h2 className="text-white text-[24px] md:text-[32px] lg:text-[40px] text-center mb-10 uppercase font-semibold">
                {title}
            </h2>
            {loading && <Loading className="fixed lg:absolute" />}

            <div className="flex flex-col lg:flex-row justify-center gap-4">

                <div className="flex justify-center lg:flex-row lg:gap-5 gap-4 lg:flex hidden w-2/5">
                    <CommonDropdown
                        selected={linksTitle}
                        options={linksFindBySize}
                        optionProperty="title"
                        onSelect={(property, selectedValue) => {
                            const selectedItem = linksFindBySize.find((value) => value.title == selectedValue);
                            handleGoToCollection(selectedItem.url);
                        }}
                        hasSearch
                        disabled={false}
                        className="w-full relative"
                        key="urls"
                    />
                </div>

                <div className="flex flex-col gap-4">
                    <ModalDropdown
                        options={linksFindBySize}
                        optionProperty="title"
                        selected={linksTitle}
                        onSelect={(property, selectedValue) => {
                            const selectedItem = linksFindBySize.find((value) => value.title == selectedValue);
                            handleGoToCollection(selectedItem.url);
                        }}
                        onOpen={() => setDropdownOpen(true)}
                        onGoBack={() => setDropdownOpen(false)}
                        showModal={dropdownOpen}
                        key="urls"
                        disabled={false}
                        className="lg:hidden flex"
                        hasSearch
                    />
                </div>

                <div className="lg:w-20 w-full lg:h-11 h-8">
                    <button
                        type="button"
                        className="transition-all duration-300 font-normal md:text-base text-base-xs flex hover:text-white hover:bg-orange-800 focus:bg-orange-800 focus:text-white bg-orange-703 lg:w-20 w-full lg:h-11 h-8 rounded-lg items-center justify-center"
                        onClick={() => { handleGoToCollection(); }}
                    >
                        Go
                    </button>
                </div>
            </div>

        </Container>
    );
};

export default ProductFindBySize;
